const ROLE_PRIORITY = ['CEO', 'TITOLARE', 'RESP_GEN', 'RESP_LOCALE', 'SEGRETERIA', 'DIPENDENTE'];

export function getPrimaryRoleCode(me) {
  const roles = Array.isArray(me?.role_codes) ? me.role_codes : [];
  return ROLE_PRIORITY.find((role) => roles.includes(role)) || null;
}

export function getBootstrapView({ loading, isAuthenticated, me, currentRoleId, error }) {
  if (loading) return 'loading';
  if (!isAuthenticated) return 'unauthenticated';
  if (error || !me || !currentRoleId) return 'error';
  return 'ready';
}